<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Drink the Tea</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para1"><a id="page_iv"></a>This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="center-para1"><span class="smallcaps">A THOMAS DUNNE BOOK FOR MINOTAUR BOOKS</span>.<br/>An imprint of St. Martin’s Publishing Group.</p>
<p class="para1"><span class="smallcaps">DRINK THE TEA</span>. Copyright © 2010 by Thomas Kaufman. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="center-para1"><a href="http://www.thomasdunnebooks.com" target="_blank">www.thomasdunnebooks.com</a><br/><a href="http://www.minotaurbooks.com" target="_blank">www.minotaurbooks.com</a></p>
<p class="center-para1">Design by Kathryn Parise</p>
<p class="center-para1"><span class="smallcaps">LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA</span></p>
<p class="para1">Kaufman, Thomas.</p>
<p class="indent-para1">Drink the tea / Thomas Kaufman. — 1st ed.</p>
<p class="indent-para1">        p. cm.</p>
<p class="indent-para1">“A Thomas Dunne book.”</p>
<p class="indent-para1">ISBN 978-0-312-60730-2</p>
<p class="indent-para1">1. Private investigators—Washington (D.C.)—Fiction. 2. Missing persons—Investigation—Fiction. 3. Daughters—Crimes against—Fiction. 4. Washington (D.C.)—Fiction. 5. Corruption—Fiction. I. Title.</p>
<p class="indent-para1">PS3611.A843D75 2010</p>
<p class="indent-para1">813'.6—dc22</p>
<p class="right-para">2009041126</p>
<p class="center-para1">First Edition: March 2010</p>
<p class="center-para1">10   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?3e361a66